import { isNotLoginBody } from '../utils/cms-errors';
import { notifySessionExpired } from '../utils/session-expired';

// cms_ai は BFF の同一オリジン中継（/ai-api）経由で呼ぶ。
// 認証（Authorization）は BFF がログイン Cookie から付けるので、フロントは token を持たない。

// BFF の中継（/ai-api）は未ログイン・ログイン切れを 401 + error.not_login で返す。
// fetch で直接呼ぶ経路は cms-axios を通らないので、ここで同じ通知を鳴らす。
export function reportAiNotLogin(res) {
  if (res?.status !== 401 || typeof res.clone !== 'function') return;
  res.clone().json()
    .then((body) => { if (isNotLoginBody(body)) notifySessionExpired(); })
    .catch(() => {});
}

// cms_ai への WebSocket URL を組み立てる。
// address が "/ai-api" のような同一オリジンの相対パスなら、ページの場所から ws(s):// を作る。
// 認証は BFF のリレーがログイン Cookie から Authorization を付けるので、token は載せない。
export function aiWsUrl(address, path) {
  if (address.startsWith('/')) {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window.location.host}${address}${path}`;
  }
  return `${address.replace(/^http/, 'ws')}${path}`;
}
